import { TestResult } from '@elementary/common-ui/types';
import dayjs from 'dayjs';
import { ApiTestResultsTableData, TestResultsTableData } from './types';

const dateFormat = 'YYYY-MM-DD HH:mm:ss';

export const parseReportTestResult = (
  testResult: TestResult,
): TestResultsTableData => ({
  subTestUniqueId: testResult.metadata.elementary_unique_id,
  databaseName: testResult.metadata.database_name,
  schemaName: testResult.metadata.schema_name,
  tableName: testResult.metadata.table_name,
  columnName: testResult.metadata.column_name,
  testName: testResult.metadata.test_name,
  testType: testResult.metadata.test_type,
  testSubType: testResult.metadata.test_sub_type,
  sourceType: 'dbt',
  qualityDimension: testResult.metadata.quality_dimension,
  testTags: testResult.metadata.test_tags,
  testOwners: testResult.metadata.test_owners,
  failedRows:
    testResult.test_results.failed_rows_count === -1
      ? null
      : testResult.test_results.failed_rows_count,
  description: testResult.metadata.description || '',
  latestRunTime: testResult.metadata.latest_run_time_utc
    ? dayjs(testResult.metadata.latest_run_time_utc, dateFormat)
    : testResult.metadata.latest_run_time
    ? dayjs(testResult.metadata.latest_run_time, dateFormat)
    : undefined,
  latestRunStatus: testResult.metadata.latest_run_status,
  assetLastDataModificationTime:
    testResult.asset_metadata?.last_data_modification_time,
  assetMaterialization: testResult.asset_metadata?.materialization,
  assetTags: testResult.asset_metadata?.tags,
  assetOwners: testResult.asset_metadata?.owners,
  assetSubscribers: testResult.asset_metadata?.subscribers,
  assetPath: testResult.asset_metadata?.path,
  criticalAsset: testResult.asset_metadata?.is_critical,
  assetName: testResult.asset_metadata?.name,
  testResult: testResult,
});

export const parseApiTestResultTableData = (
  test: ApiTestResultsTableData,
): TestResultsTableData => ({
  subTestUniqueId: test.execution.subTestUniqueId,
  databaseName: test.test.tableAsset?.dbName,
  schemaName: test.test.tableAsset?.schemaName,
  tableName: test.test.tableAsset?.tableName,
  columnName: test.execution.columnName,
  testName: test.test.name,
  testType: test.test.type,
  testSubType: test.execution.subType,
  sourceType: test.test.sourceType,
  qualityDimension: test.execution.qualityDimension,
  testTags: test.test.tags,
  testOwners: test.test.owners,
  failedRows: test.execution.failedRows,
  description: test.test.description,
  latestRunTime: dayjs(test.execution.executionTimestamp, dateFormat),
  latestRunStatus: test.execution.status,
  assetLastDataModificationTime: test.test.tableAsset?.lastDataModificationTime,
  assetMaterialization: test.test.tableAsset?.materialization,
  assetTags: test.test.tableAsset?.tags,
  assetOwners: test.test.tableAsset?.owners,
  assetSubscribers: test.test.tableAsset?.subscribers,
  assetPath: test.test.tableAsset?.path,
  criticalAsset: test.test.tableAsset?.isCritical,
  assetName: test.test.tableAsset?.name,
});
